import { memo } from "react";

import { Box } from "@mui/material";

const FullscreenDragOverlay = ({ icon, message, header }: { icon: JSX.Element | null; message: string | null; header: string | null }) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				width: "100%",
				height: "100%",
				backgroundColor: "rgba(0, 0, 0, 0.75)",
				zIndex: 9999,
				backdropFilter: "blur(4px)",
			}}
		>
			{icon}
			<Box sx={{ fontSize: "large" }}>{header}</Box>
			<Box sx={{ fontSize: "small" }}>{message}</Box>
		</Box>
	);
};

export default memo(FullscreenDragOverlay);
